import React from 'react';
import { formatUsdc } from '../../utils/format';

// Bar chart with rows for each income type + summary total.
// items: [{ key, label, icon, amount (BigNumber), color }]
// total: BigNumber — the accurate lifetime total (from contract's user.totalIncome)
export const IncomeBreakdown = ({ items, total }) => {
  // Calculate max for scaling
  let max = 0;
  items.forEach((it) => {
    try {
      const n = it.amount ? Number(it.amount.toString()) : 0;
      if (n > max) max = n;
    } catch (e) {}
  });
  if (max === 0) max = 1;

  return (
    <div>
      <div className="income-chart">
        {items.map((it) => {
          let val = 0;
          try { val = it.amount ? Number(it.amount.toString()) : 0; } catch (e) {}
          const pct = (val / max) * 100;
          return (
            <div key={it.key} className="income-bar-row">
              <span className="label">
                <span>{it.icon}</span> {it.label}
              </span>
              <div className="income-bar-track">
                <div
                  className="income-bar-fill"
                  style={{
                    width: `${Math.max(4, pct)}%`,
                    background: it.color || 'var(--grad-primary)'
                  }}
                />
              </div>
              <span className="amount">${formatUsdc(it.amount)}</span>
            </div>
          );
        })}
      </div>

      {total != null && (
        <div className="income-total-row">
          <div className="income-total-label">
            <span style={{ fontSize: 18 }}>💰</span>
            <span>Total Income Earned</span>
          </div>
          <div className="income-total-amount">${formatUsdc(total)}</div>
        </div>
      )}
    </div>
  );
};
